export default "__VITE_ASSET__e442f2bc__"